Object.defineProperty(Object.prototype, 'defEqual', {
    // enumerable: false,
    // configurable: false,
    // writable: false, 
    value: function (compareValue) {
        return Object.defEqual(this, compareValue);
    }
});
export {};
